import type { PropsWithChildren } from "react"

/* This component is used to stop the propagation of click events. */
export function StopPropagation({ children }: PropsWithChildren) {
  // biome-ignore lint: reason
  return <div onClick={(e) => e.stopPropagation()}>{children}</div>
}
